"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRegisterUserMutation = exports.useUpdateUserMutation = exports.useDeleteUserMutation = exports.useSearchUsersQuery = exports.useFetchUsersQuery = exports.userApi = void 0;
// api/userApi.ts
var react_1 = require("@reduxjs/toolkit/query/react");
var baseQueryWithReauth_1 = require("../../utils/baseQueryWithReauth");
exports.userApi = (0, react_1.createApi)({
    reducerPath: "userApi",
    baseQuery: (0, baseQueryWithReauth_1.baseQueryWithReauth)(process.env.LETS_CUE_API),
    tagTypes: ["users"],
    endpoints: function (builder) { return ({
        registerUser: builder.mutation({
            query: function (obj) { return ({
                url: "/v1/user/register",
                method: "POST",
                body: obj,
            }); },
            invalidatesTags: ["users"],
        }),
        fetchUsers: builder.query({
            query: function (obj) { return ({
                url: "/v1/user/client/".concat(obj.clientId),
                method: "GET",
                params: {
                    page: obj.page,
                    limit: obj.limit,
                },
            }); },
            providesTags: ["users"],
        }),
        deleteUser: builder.mutation({
            query: function (_a) {
                var userId = _a.userId;
                return ({
                    url: "/v1/user/remove?_id=".concat(userId),
                    method: "DELETE",
                });
            },
            invalidatesTags: ["users"],
        }),
        updateUser: builder.mutation({
            query: function (obj) { return ({
                url: "/v1/user/update",
                method: "PUT",
                body: obj,
            }); },
            invalidatesTags: ["users"],
        }),
        searchUsers: builder.query({
            query: function (obj) {
                var params = {
                    page: obj.page || 1,
                    limit: obj.limit || 10,
                };
                if (obj.search)
                    params.search = obj.search;
                if (obj.role)
                    params.role = obj.role;
                if (obj.pwdResetRequired !== undefined)
                    params.pwdResetRequired = obj.pwdResetRequired;
                if (obj.isActive !== undefined)
                    params.isActive = obj.isActive;
                return {
                    url: "/v1/user/client/".concat(obj.clientId),
                    method: "GET",
                    params: params,
                };
            },
            providesTags: ["users"],
        }),
    }); },
});
exports.useFetchUsersQuery = exports.userApi.useFetchUsersQuery, exports.useSearchUsersQuery = exports.userApi.useSearchUsersQuery, exports.useDeleteUserMutation = exports.userApi.useDeleteUserMutation, exports.useUpdateUserMutation = exports.userApi.useUpdateUserMutation, exports.useRegisterUserMutation = exports.userApi.useRegisterUserMutation;
